export type TabType = 'transfer' | 'trade' | 'spark' | 'progress';

export interface Network {
  id: string;
  name: string;
  description: string;
  logo: string;
}

export interface Token {
  id: string;
  symbol: string;
  name: string;
  color: string;
  logo: string;
  network?: string;
  address?: string;
  decimals?: number;
  isNative?: boolean;
}

export interface SparkWallet {
  id: number;
  chain: string;
  address: string;
  amount: string;
  error: string;
  showChainSelector: boolean;
  chainSearch: string;
}

export interface TransferData {
  transferId: string;
  sourceNetwork: string;
  destNetwork: string;
  amount: string;
  depositAddress: string;
  timeRemaining: number;
}

export interface TradeData {
  sourceNetwork: string;
  destNetwork: string;
  fromToken: string;
  toToken: string;
  amount: string;
  depositAddress: string;
  timeRemaining: number;
}

export const colors = {
  primary: '#00e5ff',
  secondary: '#1e4a5f',
  accent: '#00d4ff',
  purple: '#2a4a5f',
  blue: '#1a3a4a',
  cyan: '#00e5ff',
  pink: '#00d4ff',
  dark: '#0c1621',
  darker: '#0a1419',
  darkest: '#050a0f',
  text: '#ffffff',
  textSecondary: '#7a8fa5',
  textMuted: '#4a5a6a',
  border: '#1a2a3a',
  borderLight: '#2a3a4a',
  success: '#00ff88',
  error: '#ff4757',
  warning: '#ffa500',
  gradient: {
    primary: 'linear-gradient(135deg, #00e5ff 0%, #00d4ff 100%)',
    secondary: 'linear-gradient(135deg, #1e4a5f 0%, #2a4a5f 100%)',
    accent: 'linear-gradient(135deg, #00e5ff 0%, #00d4ff 100%)',
    dark: 'linear-gradient(135deg, #050a0f 0%, #0a1419 50%, #0c1621 100%)',
  }
};

// Networks and tokens are now fetched dynamically from the backend API
// See utils/api.ts for fetch functions